"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BasicBlocks_1 = require("./DataModels/BasicBlocks");
var Text_1 = require("./DataModels/Text");
var ListItem_1 = require("./DataModels/ListItem");
var LineBreak_1 = require("./DataModels/LineBreak");
var GoogleMaps_1 = require("./DataModels/GoogleMaps");
var Iframe_1 = require("./DataModels/Iframe");
var Image_1 = require("./DataModels/Image");
var MediaVariable_1 = require("./DataModels/MediaVariable");
var ContentLoop_1 = require("./DataModels/ContentLoop");
var Video_1 = require("./DataModels/Video");
var Table_1 = require("./DataModels/Table");
var SideBySide_1 = require("./DataModels/SideBySide");
var Variables_1 = require("./DataModels/Variables");
var Button_1 = require("./DataModels/Button");
var Link_1 = require("./DataModels/Link");
var ROICalculator_1 = require("./DataModels/ROICalculator");
var Accordion_1 = require("./DataModels/Accordion");
exports.default = {
    paragraph: BasicBlocks_1.paragraph,
    heading1: BasicBlocks_1.heading1,
    heading2: BasicBlocks_1.heading2,
    blockQuote: BasicBlocks_1.blockQuote,
    listItem: ListItem_1.listItem,
    googleMaps: GoogleMaps_1.googleMaps,
    iframe: Iframe_1.iframe,
    horizontalRule: BasicBlocks_1.horizontalRule,
    image: Image_1.image,
    video: Video_1.video,
    mediaVariable: MediaVariable_1.mediaVariable,
    contentLoop: ContentLoop_1.contentLoop,
    lineBreak: LineBreak_1.lineBreak,
    text: Text_1.text,
    table: Table_1.table,
    sideBySide: SideBySide_1.sideBySide,
    variable: Variables_1.variable,
    button: Button_1.button,
    link: Link_1.link,
    roiCalculator: ROICalculator_1.roiCalculator,
    accordion: Accordion_1.accordion,
};
